export const shouldJsonStringifyBody = (body) => {
    if (body === undefined || body === null)
        return false;
    return !(typeof body === 'string' ||
        body instanceof FormData ||
        body instanceof Blob ||
        body instanceof ArrayBuffer ||
        body instanceof URLSearchParams ||
        body instanceof ReadableStream);
};
export const prepareBody = (body) => {
    if (body === undefined || body === null)
        return undefined;
    if (shouldJsonStringifyBody(body)) {
        return JSON.stringify(body);
    }
    return body;
};
